// extracted by mini-css-extract-plugin
export default {"data":"ExpandableComplexChildren_data__2yLR8","data-mobile":"ExpandableComplexChildren_data-mobile__WEoQH"};